import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import 'dayjs/locale/th' // Ensure 'th' locale is imported

const DEFAULT_TIMEZONE = 'Asia/Bangkok'

export function globalConfigDayjs() {
  dayjs.extend(utc)
  dayjs.extend(timezone)
  dayjs.extend(isBetween)
  dayjs.tz.setDefault(DEFAULT_TIMEZONE)
}

/**
  * * Create a Dayjs object in the default timezone.
  * @param {string | number | Date | dayjs.Dayjs | null | undefined} date - The date to convert.
  * @returns {dayjs.Dayjs} A Dayjs object.
  */
export function createDayjsDate(date) {
  if (date == null) {
    return dayjs.tz(new Date(), DEFAULT_TIMEZONE)
  }

  if (typeof date === 'string' && date.trim() === '') {
    return dayjs.tz(new Date(), DEFAULT_TIMEZONE)
  }

  if (typeof date === 'number') {
    return dayjs.tz(date, DEFAULT_TIMEZONE)
  }

  if (date instanceof Date) {
    return dayjs.tz(date, DEFAULT_TIMEZONE)
  }

  if (dayjs.isDayjs(date)) {
    return date.tz(DEFAULT_TIMEZONE)
  }

  return dayjs(date).tz(DEFAULT_TIMEZONE)
}
